import React, { useState, useEffect } from 'react'
import HeaderEth from '../common/HeaderEth'
import FooterEth from '../common/FooterEth'
// import * as CountryCode from "../../Config/CountryCode.js";
import { EthiopiaPlans, EthiopiaSubscription } from '../../Model/Subscription.js';
import { Image_Url } from "../../Config/config";

const LoginTelebirr = () => {
    const [contactNumber, setContactNumber] = useState("");
    const [radioOptions, setRadioOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState("");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        EthiopiaPlans().then((response) => {
            setRadioOptions(response.data.plans);
            if (response.data.plans.length > 0) {
                setSelectedOption(response.data.plans[0].product_id);
            }
        }).catch((error) => {
            console.error("Error fetching radio options:", error);
        });
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!contactNumber) {
            setError("Please enter a contact number.");

            setTimeout(() => {
                setError("");
            }, 2000);
            return;
        }
        EthiopiaSubscription(contactNumber, selectedOption).then((response) => {
            if (response.data.success) {
                setMessage(response.data.message);
                setContactNumber("");
                setTimeout(() => {
                    setMessage("");
                }, 4000);
                return;
            }
            if (response.data.success === false) {
                setErrorMsg(response.data.message);
                setContactNumber("");
                setTimeout(() => {
                    setErrorMsg("");
                }, 4000);
                return;
            }
        })
            .catch(() => {
                setMessage("Submission failed. Please try again.");
            });
    };

    return (
        <>
            <HeaderEth />
            <div className="signupnewcontainer">
                <div className="Container-signup telebirr">
                </div>
                <div className="temp2">
                    {/* <p className="text">Already subscribed?</p> */}
                    <div className="temp1Inner">
                        <div className="sub-btn">Enter your mobile number below to get the access PIN code</div>
                        <div className={"formField data formfieldone"}>
                            {/* {CountryCode.Countrycode.map((CoutryData) => {
                                return (
                                    <option
                                        key={CoutryData.name}
                                        value={CoutryData.dial_code}
                                        style={{ width: "70px", textAlign: "center" }}
                                    >
                                        {CoutryData.dial_code}
                                    </option>
                                );
                            })} */}
                            +251
                            <div class="Form-line">|</div>
                            {/* <input
                                name="fld_mobile"
                                type="tel"
                                className="inputTel"
                                placeholder="Enter your mobile number"
                                // value={this.state.fields.fld_mobile}
                                // onChange={this.handleChange}
                                // disabled={fld_mobile}
                                textcontenttype="none"
                                minLength="9"
                                maxLength="10"
                                autoCorrect="false"
                                autoComplete="off"
                                pattern="[0-9]"
                            // required
                            /> */}
                            <input
                                type="text"
                                value={contactNumber}
                                onChange={(e) => setContactNumber(e.target.value)}
                                placeholder="Enter your mobile number"
                                minLength="9"
                                maxLength="10"
                            />
                        </div>

                        {error &&
                            <div className="error error-telebirr ethio-msg">
                                <img
                                    src={
                                        process.env.PUBLIC_URL + "img/svg/error.svg"
                                    }
                                    alt="DocuBay"
                                />
                                <p>{error} </p>
                            </div>
                        }

                        <div className="radio-btn-telebirr">
                            {radioOptions.map((option) => {
                                return (
                                    <>
                                        <input
                                            id={option.product_id}
                                            type="radio"
                                            name="options"
                                            style={{ marginRight: "8px", display: "none" }}
                                            value={option.product_id}
                                            checked={selectedOption === option.product_id}
                                            onChange={() => setSelectedOption(option.product_id)}
                                        />
                                        <label htmlFor={option.product_id} key={option.product_id}>
                                            {option.price} {option.currency}/{option.product_name.split(" ").pop()}
                                        </label>
                                    </>
                                )
                            })}
                        </div>
                        <div className="formField">
                            <button
                                type="submit"
                                className={"btn-red subscibe"}
                                style={{ marginTop: "12px" }}
                                onClick={handleSubmit}
                            >
                                Subscribe Telebirr
                            </button>
                        </div>
                        {message &&
                            <div className="error success-telebirr">
                                <img src={`${Image_Url}img/svg/tick.svg`} alt="DocuBay" style={{
                                    width: "16px", height: "16px"
                                }} />
                                <p>{message} </p>
                            </div>
                        }
                        {errorMsg &&
                            <div className="error error-telebirr-msg">
                                <img src={
                                    process.env.PUBLIC_URL + "img/svg/error.svg"
                                } alt="DocuBay" style={{
                                    width: "16px", height: "16px"
                                }} />
                                <p>{errorMsg} </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <FooterEth />
        </>
    )
}

export default LoginTelebirr